module.exports = __webpack_public_path__ + "static/media/card-game-item.6af7d7a6.png";